import { Inline, Skeleton, Stack } from '@cortex/ui';

/**
 * Skeleton loader for layout pages with a sidebar.
 * Shows a placeholder sidebar + content area during auth initialization.
 *
 * Used by the App layout, Admin layout, and Settings layout.
 */
export function LayoutSkeleton() {
  return (
    <Inline gap="none" className="bg-background h-screen">
      <Stack gap="sm" className="border-border bg-background w-60 border-r p-4">
        <Skeleton className="mb-4 h-8 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </Stack>
      <Stack gap="lg" className="flex-1 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </Stack>
    </Inline>
  );
}
